import { Autocomplete, Popper, TextField } from '@mui/material';
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import { BASE_COLORS } from '../../../constants';
import { useApi } from '../../../hooks/useApi';
import useDebounce from '../../../hooks/useDebounce';

const DroughtWarningMeparSearchPopper = forwardRef(function DroughtWarningMeparSearchPopper(
    props,
    ref
) {
    return (
        <Popper
            {...props}
            ref={ref}
            sx={[
                {
                    mt: 0.5,
                    borderRadius: 1,
                    '& .MuiAutocomplete-paper': {
                        borderRadius: 1,
                        overflow: 'hidden',
                        border: `1px solid ${BASE_COLORS.BACKGROUND_LIGHT_GRAY}`,
                        boxShadow: '0 10px 24px rgba(0, 0, 0, 0.12)',
                    },
                },
                props.sx,
            ]}
        />
    );
});

const DroughtWarningMeparSearch = ({ onSelectMepar = () => {}, selectedMeparCode = '' }) => {
    const [searchInput, setSearchInput] = useState(selectedMeparCode);
    const [searchPhrase, setSearchPhrase] = useState(selectedMeparCode);

    useEffect(() => {
        setSearchInput(selectedMeparCode);
        setSearchPhrase(selectedMeparCode);
    }, [selectedMeparCode]);

    useDebounce(() => setSearchPhrase(searchInput.trim()), [searchInput], 300);

    const [result, loading] = useApi(
        (api, params) =>
            api.blocks.searchBlocks(
                {
                    phrase: encodeURIComponent(searchPhrase) || undefined,
                    limit: 10,
                },
                params
            ),
        [searchPhrase],
        (data) => data,
        !searchPhrase
    );

    const options = result || [];

    const selectedOption = useMemo(() => {
        if (!selectedMeparCode) {
            return null;
        }

        return (
            options.find((option) => option.meparCode === selectedMeparCode) || {
                id: selectedMeparCode,
                meparCode: selectedMeparCode,
            }
        );
    }, [options, selectedMeparCode]);

    return (
        <Autocomplete
            fullWidth
            options={options}
            value={selectedOption}
            inputValue={searchInput}
            loading={loading}
            PopperComponent={DroughtWarningMeparSearchPopper}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option.meparCode || ''}
            onChange={(_, newValue) => {
                const nextMeparCode = newValue?.meparCode || '';
                setSearchInput(nextMeparCode);
                setSearchPhrase(nextMeparCode);
                onSelectMepar(newValue);
            }}
            onInputChange={(_, newInputValue, reason) => {
                if (
                    reason === 'reset' &&
                    selectedMeparCode &&
                    newInputValue === selectedMeparCode &&
                    searchInput !== selectedMeparCode
                ) {
                    return;
                }

                setSearchInput(newInputValue);

                if (reason === 'clear') {
                    onSelectMepar(null);
                }
            }}
            noOptionsText={searchInput ? 'Nincs találat' : 'Adja meg a MePAR azonosítót'}
            isOptionEqualToValue={(option, value) => option.meparCode === value.meparCode}
            renderInput={(params) => (
                <TextField {...params} placeholder="Válasszon mepar kódot" fullWidth size="small" />
            )}
            sx={{
                width: { xs: '100%', sm: 300, lg: 360 },
                minWidth: 0,
                backgroundColor: '#fff',
                borderRadius: 1,
                '& .MuiOutlinedInput-root': {
                    backgroundColor: '#fff',
                },
            }}
        />
    );
};

export default DroughtWarningMeparSearch;
